/**
 * Backend operation limits.
 * These limits must match the backend constants exactly.
 */
export const BackendLimits = {
  // Upload operations
  MAX_PODS_PER_NODE: 1000,
  MAX_NODES_PER_ROOT: 100,

  // Bulk operations
  MAX_PODS_PER_OPERATION: 500,
  MAX_NODES_PER_OPERATION: 500,
  MAX_PODS_PER_DELETE: 100,

  // Recycle bin operations
  MAX_PODS_PER_RESTORE: 100,

  // Download operations
  MAX_PODS_PER_DOWNLOAD: 5000,
  MAX_NODES_PER_DOWNLOAD: 5000,
  MAX_ASSETS_PER_DOWNLOAD: 5000,
};
